import * as parser from 'query-string';
import configureStore from '../store/configureStore';
import { HttpRequestHeader } from 'antd/lib/upload/interface';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

interface fetchAPIOptions extends RequestInit {
  auth?: boolean; // if true, auth token is put into Headers, else it's put into query string.
  payload?: {};
  token?: string;
  version?: string;
  is_json?: boolean;
}

export const getToken = (): string | undefined => {
  const state = configureStore().getState();
  if (state.users && state.users.token) {
    return state.users.token;
  }
  if (window.hasOwnProperty('localStorage')) {
    const item = JSON.parse(window.localStorage.getItem('sourcesage') || '{}');
    if (item && item.users && item.users.token) {
      return item.users.token;
    }
  }
  const token = parser.parse(window.location.search).token;
  return token;
};

export const _getLang = (): string | undefined => {
  const lang = parser.parse(window.location.search).lang;
  if (lang) {
    return lang;
  }
  const state = configureStore().getState();
  return state.i18n.locale;
};

export function fetchAPI(
  endpoint: string,
  options?: fetchAPIOptions
): Promise<Response> {
  const {
    auth = true,
    payload = {},
    version = '1.1',
    method = 'GET',
    is_json = true,
    ...fetchOptions
  }: fetchAPIOptions = options || {};

  let body;

  let headers = {};
  let qs = {};
  const token = getToken();
  const lang = _getLang();

  if (lang) {
    headers = { ...headers, 'Accept-Language': lang };
  }

  if (is_json) {
    headers = { ...headers, ...defaultHeaders };
  }

  headers = { ...headers, ...fetchOptions.headers };

  if (auth && token) {
    headers = { ...headers, Authorization: `Bearer ${token}` };
  }

  if (method === 'GET') {
    qs = { ...qs, ...payload };
  } else {
    // for safari, you can't pass empty {} to body ...
    body = Object.keys(payload).length ? JSON.stringify(payload) : undefined;
  }

  const maybe_qs = Object.keys(qs).length ? `?${parser.stringify(qs)}` : '';
  const url = `${__API_HOST__}/api/v${version}${endpoint}${maybe_qs}`;
  return window.fetch(url, {
    headers: new Headers(headers),
    method,
    body,
  });
}

export function getAuthorizationHeaders(): HttpRequestHeader | undefined {
  const token = getToken();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return undefined;
}

function updateQueryStringParameter(uri, key, value): string {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
}

export function buildLink(url: string, isMobile: boolean) {
  const newURL = updateQueryStringParameter(url, 'token', getToken());
  return isMobile ? `/m${newURL}` : newURL;
}
/**
 * Build data page endpoint base on platform.
 * @param isMobile
 */
export function buildDataPageLink(isMobile: boolean) {
  const newURL = updateQueryStringParameter(
    isMobile ? '/my-data-page' : '/dashboard/benchmark',
    'token',
    getToken()
  );
  return isMobile ? `/m${newURL}` : newURL;
}

export function getUrlParams() {
  return parser.parse(window.location.search);
}



// WEBPACK FOOTER //
// ./app/utils/api.ts